import { autorun } from 'mobx'
import { useEffect, useMemo, useState } from 'react'
import { useRouter } from '../../hooks/router'
import { useStore } from '../../hooks/store'
import { HomePageView } from './HomePageView'

export const HomePage = function HomePage() {
  const store = useStore()

  const [showOnboarding, setShowOnboarding] = useState(false)

  const templates = useMemo(
    () => store.buildTemplateCollection({ limit: 5, order: 'recently_used' }),
    []
  )

  const recentChecklists = useMemo(
    () =>
      store.buildChecklistCollection({
        limit: 20,
        order: 'recently_completed',
        complete: true,
      }),
    []
  )

  const currentChecklists = useMemo(
    () =>
      store.buildChecklistCollection({
        limit: 5,
        order: 'recently_completed',
        complete: false,
        assignee: 'me_or_nobody',
      }),
    []
  )

  useEffect(() => {
    const refetch = async () => {
      void recentChecklists.fetch()
      void currentChecklists.fetch()
      void templates.fetch()
    }
    refetch()
    window.addEventListener('focus', refetch)
    return () => {
      window.removeEventListener('focus', refetch)
    }
  }, [])

  useEffect(() => {
    return autorun(() => {
      if (!templates.isReady) return
      if (!recentChecklists.isReady) return
      if (!currentChecklists.isReady) return
      const templateCount = templates.items.length
      const checklistCount = recentChecklists.items.length
      const activeChecklistCount = currentChecklists.items.length
      if (
        templateCount === 0 &&
        checklistCount === 0 &&
        activeChecklistCount === 0
      ) {
        setShowOnboarding(true)
      }
    })
  }, [])

  return (
    <HomePageView
      templates={templates}
      currentChecklists={currentChecklists}
      recentChecklists={recentChecklists}
      showOnboarding={showOnboarding}
    />
  )
}
